<template>
  <section>
    <div id="whywe" class="pd70 wbg">
      <UiBg />
      <div class="wrapper w1200">
        <UiAnim tag="h2" class="block_title">Почему выбирают нас</UiAnim>

        <UiAnim class="whywe_box" v-for="(it, i) in items" :key="i">
          <img alt="" :src="`/static/image/icon/${it.icon}.png`" />
          <UiAnim tag="h3">{{ it.title }}</UiAnim>
          <UiAnim tag="p">{{ it.text }}</UiAnim></UiAnim
        >
        <span class="clr"></span>
      </div>
    </div>
  </section>
</template>

<script setup>
const items = [
  {
    title: "Удобное месторасположение",
    text: "в центре г.Москва",
    icon: "place-marker",
  },
  {
    title: "Квалифицированный персонал",
    text: "с трепетным отношением к Вашему автомобилю",
    icon: "users",
  },
  {
    title: "Гарантия на работы и комплектующие",
    text: "1 год",
    icon: "certificate",
  },
  {
    title: "Строгое соблюдение сроков",
    text: "работаем быстро без ущерба для качества",
    icon: "speed",
  },
];
</script>
